import { WidgetComponent } from "../widget.component";
import { WIDGET_GOOGLE_DOCS } from "../../../shared/models/widget";
import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
    template: require('./gdoc.widget.component.html'),
    styles: [require('./gdoc.widget.component.scss')],
})
export class GoogleDocsWidgetConfigComponent extends WidgetComponent {
    constructor(public translate: TranslateService) {
        super(WIDGET_GOOGLE_DOCS, "Google Doc", "generic", translate , "googleDocs");
    }
}
